import * as React from "react";
const SvgFiRrBallPile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ball-pile_svg__a)">
      <path
        fill="#062147"
        d="M20.016 13.695a4.6 4.6 0 0 0 .318-1.682 4.686 4.686 0 0 0-3.985-4.634 4.6 4.6 0 0 0 .318-1.682c0-2.583-2.093-4.684-4.667-4.684s-4.667 2.1-4.667 4.684c0 .579.11 1.148.321 1.682a4.685 4.685 0 0 0-3.988 4.634c0 .58.111 1.15.318 1.682A4.684 4.684 0 0 0 0 18.328c0 2.583 2.093 4.685 4.667 4.685a4.66 4.66 0 0 0 3.667-1.79 4.66 4.66 0 0 0 3.667 1.79 4.66 4.66 0 0 0 3.667-1.79 4.66 4.66 0 0 0 3.667 1.79c2.573 0 4.667-2.102 4.667-4.685a4.684 4.684 0 0 0-3.984-4.633zM12.529 3.064c1.268.247 2.137 1.436 2.137 2.728 0 1.429-1.194 2.588-2.623 2.588-1.678 0-2.71-1.21-2.71-2.683 0-1.654 1.495-2.964 3.196-2.632zM4.71 21.012c-1.678 0-2.71-1.21-2.71-2.683 0-1.654 1.495-2.964 3.196-2.632 1.268.247 2.137 1.436 2.137 2.728 0 1.429-1.194 2.588-2.623 2.588zm3.667-6.317c-1.678 0-2.71-1.21-2.71-2.683 0-1.654 1.495-2.964 3.196-2.632C10.131 9.627 11 10.816 11 12.108c0 1.429-1.194 2.588-2.623 2.588zm3.667 6.317c-1.678 0-2.71-1.21-2.71-2.683 0-1.654 1.495-2.964 3.196-2.632 1.268.247 2.137 1.436 2.137 2.728 0 1.429-1.194 2.588-2.623 2.588zm3.918-6.421c-1.678 0-2.71-1.21-2.71-2.683 0-1.654 1.495-2.964 3.196-2.632 1.268.247 2.137 1.436 2.137 2.728 0 1.429-1.194 2.588-2.623 2.588zm3.415 6.42c-1.678 0-2.71-1.21-2.71-2.682 0-1.654 1.495-2.964 3.196-2.632 1.268.247 2.137 1.436 2.137 2.728 0 1.429-1.194 2.588-2.623 2.588z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ball-pile_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBallPile;
